import React, {Component} from 'react';
import {Col, Form, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, UncontrolledTooltip} from "reactstrap";
import NumberFormat from "react-number-format";
import {showAxiosError} from "../../../helper/helper";
import {request} from "../../../helper/APIUtils";
import Alert from "react-s-alert";
import {Decimal} from "decimal.js";
import {CopyToClipboard} from "react-copy-to-clipboard";
import Table from "../../../components/Table/Table";
import {validateField} from "../../../common/validation";
import TextOverFlowTooltip from "../../../components/TextOverFlowTooltip";
import Select from "../../../local_node_modules/react-select";
import Switch from "react-switch";

class ExternalPaymentModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            amount: "",
            explanation: "",
            customer: {},
            eBelgeUsers: [],
            content: [],
            total: 0,
            page: 0,
            size: 5,
            manual: false,
            loading: false,
            paymentType: 0,
            symbol: ' ₺',
            externalPayment: 'OTHER'
        };
        this.onValueChange = this.onValueChange.bind(this);
        this.fetchPaymentInformation = this.fetchPaymentInformation.bind(this);
        this.payment = this.payment.bind(this);
        this.copied = this.copied.bind(this);
        this.setPaymentType = this.setPaymentType.bind(this);
        this.savePayment = this.savePayment.bind(this);
        this.getPaymentStatus = this.getPaymentStatus.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateField = this.validateField.bind(this);
        this.externalPaymentList = this.externalPaymentList.bind(this);
    }

    componentDidMount() {
        this.setState({loading: true, customer: this.props.customer}, () => this.fetchPaymentInformation(null, null, this.state.page, this.state.size) );
    }

    copied(paymentLink) {
        if (paymentLink) {
            Alert.success("Ödeme Linki Kopyalandı", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000,
                html: false
            });
        }
    }

    setPaymentType(e) {
        this.setState({paymentType: e && e === true ? 0 : 44})
    }

    payment(merchantOid) {
        window.location.href = this.props.paytrDomain + "/external/" + merchantOid;
    }

    async fetchPaymentInformation(accessor, direction, page, size) {
        let self = this;
        let customerId = this.props.customer.recordId;
        let params = {
            url: "/payTrOrder/fetchExternalPayment?page=" + page + '&size=' + size,
            method: "post",
            data: customerId
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual});
        await request(params).then((response) => {
            self.setState({
                content: response.data.content,
                loading: false,
                manual: false,
                page: page,
                size: size,
                total: response.data.totalElements
            });
        }).catch(function (error) {
            self.setState({manual:false, loading: false});
            showAxiosError(error);
        });

    }

    savePayment() {
        let self = this;
        let {amount, paymentType, explanation, customer} = this.state;
        let order = {}
        let errorMessage = "";
        let selectedCustomer = {
            recordId: customer.recordId,
            customerName: customer.customerName,
            vknTckn: customer.vknTckn
        };

        if (paymentType == null) {
            paymentType = 44;
        }

        if (amount == 0 || amount === null || amount === "") {
            errorMessage = errorMessage + " <strong>Ödeme miktarı boş veya 0" + `${this.state.symbol}` + " değerinde olamaz.</strong><br/>";
        }

        if(explanation === null || explanation === ""){
            errorMessage = errorMessage + " <strong>Açıklama alanı boş olamaz.</strong><br/>";
        }

        if(errorMessage !== ""){
            Alert.error(errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
            return;
        }

        order["merchantFailUrl"] = window.location.origin + "/accounting/customer";
        order["merchantOkUrl"] = window.location.origin + "/accounting/customer";
        order["vknJson"] = JSON.stringify([selectedCustomer]);
        order["payTrOrderLines"] = [{unit: 99, count: 0, price: amount}];
        order["paymentType"] =  "EXTERNAL_PAYMENT_" + this.state.externalPayment;
        this.setState({saveLoading: true});
        let params = {
            url: `/payTrOrder/saveExternalPayment?customerVknTckn=${customer.vknTckn}&paymentType=${paymentType}&explanation=${explanation}`,
            method: "post",
            data: order
        };
        request(params)
            .then(function (response) {
                let order = response.data;
                if (paymentType === 0) {
                    setTimeout(function () {
                        self.setState({saveLoading: false});
                        window.location.href = self.props.paytrDomain + "/external/" + order.merchantOid;
                    }, 100);
                } else {
                    setTimeout(() => {
                    self.setState({saveLoading: false, content: [], amount: "", explanation: ""}, () => self.fetchPaymentInformation(null, null, self.state.page, self.state.size));
                }, 100);
                }
                Alert.success("Ödeme linki oluşturuldu.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 2000
                });
            }).catch(function (error) {
            showAxiosError(error);
        }).then(function () {
            self.setState({saveLoading: false, loading: false});
        });
    }

    onValueChange(value, name) {
        if (name === "amount") {
            if (value.length > 0) {
                this.setState({amount: (new Decimal(value)).toNumber()})
            } else {
                this.setState({amount: null})
            }
        }else {
            this.setState({[name]: value})
        }
    }

    getPaymentStatus(status) {
        let htmlResult = "";
        if (status === 0) {
            htmlResult = "ÖDEME BEKLENİYOR"
        } else if (status === 1) {
            htmlResult = "ÖDEME BAŞARISIZ"
        } else if (status === 2) {
            htmlResult = "ÖDEME BAŞARILI"
        } else {
            htmlResult = "";
        }
        return (
            <span>
        <p style={{margin: 0}}
           className={status === 2 ? "text-success" : (status === 1 ? "text-danger" : (status === 0 ? "text-info" : "text-secondary"))}>
				{htmlResult}
        </p>
        </span>
        );
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    externalPaymentList() {
        return [
            {value: "OTHER", label: "Diğer"},
        ]
    }

    render() {
        let columns = [
            {
                Header: "VKN/TCKN",
                title: "VKN/TCKN",
                accessor: "vknTckn",
                sortable: false,
                width: "10%",
            },
            {
                Header: "Unvan",
                title: 'Unvan',
                accessor: "customerName",
                sortable: false,
                Cell: row => (<div><TextOverFlowTooltip text={row.customerName} maxLength={20}/></div>),
                width: "10%",
            },
            {
                Header: "Ödenecek Tutar",
                title: 'Ödenecek Tutar',
                accessor: "totalPrice",
                sortable: false,
                Cell: row => (
                    <div>{row.totalPrice} {this.state.symbol}</div>
                ),
                width: "10%",
            },
            {
                Header: "KDV(%20)",
                title: 'KDV(%20)',
                accessor: "",
                sortable: false,
                Cell: row => (
                    <div>{(row.totalPrice - row.price).toFixed(2)} {this.state.symbol}</div>
                ),
                width: "10%",
            },
            {
                Header: "Ödeme Durumu",
                title: 'Ödeme Durumu',
                accessor: "",
                sortable: false,
                Cell: row => (
                    <div style={{margin: 0}}>{this.getPaymentStatus(row.status)}</div>
                ),
                width: "10%",
            },
            {
                Header: "Açıklama",
                title: 'Açıklama',
                accessor: "explanation",
                sortable: false,
                Cell: row => (<div><TextOverFlowTooltip text={row.explanation} maxLength={20}/></div>),
                width: "10%",
            },
            {
                Header: "Tarih",
                title: 'Tarih',
                accessor: "createdAt",
                sortable: false,
                width: "10%",
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                width: "10%",
                Cell: row => (
                    <div>
                        <div>
                            {row.status !== 2 ?
                                <>
                                    <button type="button" onClick={() => this.payment(row.merchantOid)} rel="tooltip"
                                            className="Btn btn-icon" title="Ödeme Yap"
                                            style={{background: 'rgb(52, 216, 103)'}}>
                                        <i className="fa fa-credit-card"/>
                                    </button>
                                    <CopyToClipboard text={this.props.paytrDomain + "/external/" + row.merchantOid}
                                                     onCopy={() => this.copied(this.props.paytrDomain + "/external/" + row.merchantOid)}>
                                        <button type="button" rel="tooltip"
                                                className="Btn btn-icon" title="Ödeme Linkini Kopyala"
                                                style={{background: 'rgb(52, 216, 103)'}}>
                                            <i className="fa fa-clipboard"/>
                                        </button>
                                    </CopyToClipboard>
                                </>
                                :
                                <p>-</p>
                            }
                        </div>
                    </div>
                )
            }
        ];
        return (
            <div>
                <Modal isOpen={this.props.isOpen} size='lg'>
                    <ModalHeader toggle={() => this.props.toggle()}>Harici Ödeme İşlemleri</ModalHeader>
                    <ModalBody style={{paddingTop: '4px'}}>
                        <div>
                            <Form className="bg-light" style={{marginTop: '15px'}}>
                                <div>
                                    <Col xs="12">
                                        <Row >
                                            <Col xs="12" sm="6">
                                                <Row style={{marginBottom: '20px'}}>
                                                    <Col xs='12'>
                                                        <Label for="fiyat">Fiyat(₺)</Label>
                                                    </Col>
                                                    <Col xs='12'>
                                                        <NumberFormat id="fiyat"
                                                                      value={this.state.amount}
                                                                      disabled={false}
                                                                      allowNegative={false}
                                                                      isNumericString={true}
                                                                      allowEmptyFormatting={false}
                                                                      decimalScale={9}
                                                                      thousandSeparator={'.'}
                                                                      decimalSeparator={','}
                                                                      displayType="input"
                                                                      placeholder="Tutar Giriniz."
                                                                      renderText={value => {
                                                                          value.replace(/\./g, ',')
                                                                      }}
                                                                      suffix={this.state.symbol}
                                                                      onValueChange={e => this.onValueChange(e.value, "amount")}
                                                                      className="form-control"/>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xs="12" sm="6" >
                                                <Row style={{marginBottom: '20px'}}>
                                                    <Col xs='12'>
                                                        <Label for="explanation">Açıklama *</Label>
                                                    </Col>
                                                    <Col xs='12'>
                                                        <div className={"form-group" + this.validateClass("explanation")}>
                                                        <input className="form-control"
                                                               type="text"
                                                               data-vlength="1,255"
                                                               id="explanation"
                                                               name="explanation"
                                                               onBlur={(e) => this.validateField(e)}
                                                               onChange={e => this.onValueChange(e.target.value, "explanation")}
                                                               value={this.state.explanation}/>
                                                        {this.validateMessage("explanation") !== "" &&
                                                            <UncontrolledTooltip placement="right"
                                                                                 target={"explanation"} delay={0}>
                                                                {this.validateMessage("explanation")}
                                                            </UncontrolledTooltip>}
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col xs="12">
                                        <Row >
                                            <Col xs="12" sm="6">
                                                <Row style={{marginBottom: '20px'}}>
                                                    <Col xs='12'>
                                                        <br/>
                                                    </Col>
                                                    <Col xs='12'>
                                                        <div style={{paddingTop: "0px"}}>
                                                            <Label style={{paddingRight: "15px", paddingTop: "14px", verticalAlign: "super"}} for="paymentType">{this.state.paymentType === 0 ? "Faturası Kesilsin" : "Faturası Kesilmesin"}</Label>
                                                            <Switch
                                                                id={"paymentType"}
                                                                checked={this.state.paymentType === 0}
                                                                disabled={false}
                                                                onChange={(e) => this.setPaymentType(e)}
                                                                onColor="#86d3ff"
                                                                onHandleColor="#2693e6"
                                                                handleDiameter={20}
                                                                uncheckedIcon={false}
                                                                checkedIcon={false}
                                                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                                height={15}
                                                                width={30}
                                                                className="react-switch"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xs="12" sm="6" >
                                                <Row style={{marginBottom: '20px'}}>
                                                    <Col xs='12'>
                                                        <Label for="externalPayment">Ödeme ne için</Label>
                                                    </Col>
                                                    <Col xs='12'>
                                                        <Select id="externalPayment"
                                                                name="externalPayment"
                                                                value={this.state.externalPayment}
                                                                clearable={false}
                                                                placeholder="Seçiniz..."
                                                                noResultsText="Kayıt bulunamadı."
                                                                onChange={(e) => this.onValueChange( e.value, "externalPayment")}
                                                                options={this.externalPaymentList()}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: "flex-end",
                                    borderRadius: '5px',
                                    margin: '5px 0'
                                }}>
                                    <button type="button" data-toggle="tooltip" data-placement="bottom"
                                            style={{
                                                background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                                letterSpacing: '1px',
                                                marginRight: '15px',
                                                marginBottom: '15px'
                                            }}
                                            disabled={this.state.saveLoading}
                                            rel="tooltip"
                                            className="TekBtn kaydet btn-icon"
                                            title='Kaydet'
                                            onClick={(e) => this.savePayment()}>Ödeme Linki Oluştur
                                    </button>
                                </div>
                            </Form>
                        </div>

                        <Row>
                            <div className="card-header ">
                                <h4 className="card-title">Ödeme Linki Listesi</h4>
                            </div>
                            <Col xs="12" >
                                <Table columns={columns}
                                       content={this.state.content}
                                       total={this.state.total}
                                       page={this.state.page}
                                       size={this.state.size}
                                       loading={this.state.loading}
                                       options={["5", "10", "20", "50", "100"]}
                                       fetchData={this.fetchPaymentInformation}
                                       manual={this.state.manual}
                                />
                            </Col>
                        </Row>

                    </ModalBody>
                    <ModalFooter>
                        <button type="button" onClick={this.props.toggle}
                                className=" TekBtn vazgec" style={{
                            background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                            padding: '9px 45px 9px 20px'
                        }}>
                            Vazgeç
                        </button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default ExternalPaymentModal;